import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useState, useEffect, useCallback, useContext } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import "../index.css";
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';

const Manga = () => {
    const [activePage, setActivePage] = useState("Learning");
    const location = useLocation();
    const navigate = useNavigate();
    const QuizData = location.state;
    const quizTypeId = QuizData?.quiz_id;
    const quizName = QuizData?.quiz_name;
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const { Translate } = useContext(ProductContext);

    return (
        <>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{quizName}</h2>


                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>


                    </div>
                </div>
            </div>
            <div className="Manga_container">

                <div className="MangaPdf container my-5">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga1.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga2.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga3.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga4.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga5.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga6.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga7.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga8.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/assets/images/manga9.jpg`}
                                alt="Penguine"
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                </div>

                      <Footer />
            </div>
        </>
    )
}

export default Manga